/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import VirtualSection from './VirtualSection';
import {
  useAddingInitialRows,
  useFormSelector,
  useInitializingGridFromDatasource,
} from '../../../../custom-hooks';
import {
  applyFormLevelAddRowRule,
  applyFormLevelClearTableRule,
} from '../../../actions/runtime.actions';
import { FORM_MODEL_ATTRIBUTES } from '../../../constants/form-manager.constants';
import {
  getEvaluatedConditionsForInteractionAction,
  getIsParentlessTable,
} from '../../../selectors/form-manager.selectors';
import {
  getEvaluatedTableRowsProperties,
  getVirtualRows,
} from '../../../selectors/ssGrid.selectors';
import { equalityFn } from '../../../utils/form-manager.utils';
import { getTableRowsEqualityFn } from '../../../utils/runtime.utils';

const SSVirtualRepeatingPanel = ({
  id,
  index,
  entityName,
  formKey,
  initialRows,
  isHidden,
  isViewOnly,
  childrenNodes,
  addRowRules: { logInfo: addRuleLogInfo } = {},
  clearTableRules: { logInfo: clearTableLogInfo } = {},
  rebindCanvasRules: { logInfo: rebindCanvasLogInfo } = {},
  containersProps,
}) => {
  const isParentlessTable = useFormSelector(getIsParentlessTable, { id });
  const selectorProps = { id, index, entityName, isParentlessTable };
  const [isRebindCanvas, setIsRebindCanvas] = useState(false);

  const dispatch = useDispatch();
  const rows = useFormSelector(
    getVirtualRows,
    selectorProps,
    getTableRowsEqualityFn(isParentlessTable)
  );
  const shouldAddDefaultRow = useFormSelector(getEvaluatedConditionsForInteractionAction, {
    ...selectorProps,
    prop: FORM_MODEL_ATTRIBUTES.ADD_ROW_RULES,
  });
  const shouldClearTable = useFormSelector(getEvaluatedConditionsForInteractionAction, {
    ...selectorProps,
    prop: FORM_MODEL_ATTRIBUTES.CLEAR_TABLE_RULES,
  });
  const shouldRebindCanvas = useFormSelector(getEvaluatedConditionsForInteractionAction, {
    ...selectorProps,
    prop: FORM_MODEL_ATTRIBUTES.REBIND_CANVAS_RULES,
  });
  const disableEditFilter = useFormSelector(
    getEvaluatedTableRowsProperties,
    {
      ...selectorProps,
      prop: FORM_MODEL_ATTRIBUTES.DISABLE_EDIT,
    },
    equalityFn
  );

  const rowIndexKey = isParentlessTable ? 'gridArrIndex' : 'index';
  const rowsLength = rows.filter((row) => !row.isFilteredOut).length;

  useAddingInitialRows({
    initialRows,
    selectorProps,
    isVirtualComponent: true,
    isRebindCanvas,
    rebindCanvasLogInfo,
  });

  useInitializingGridFromDatasource({
    rowsLength,
    selectorProps,
    isVirtualComponent: true,
    isRebindCanvas,
    rebindCanvasLogInfo,
  });

  useEffect(() => {
    if (shouldAddDefaultRow) {
      dispatch(applyFormLevelAddRowRule({ addRuleLogInfo, index, entityName, formKey }));
    }
  }, [shouldAddDefaultRow]);

  useEffect(() => {
    if (shouldClearTable) {
      dispatch(
        applyFormLevelClearTableRule({ clearTableLogInfo, index, entityName, formKey, rows })
      );
    }
  }, [shouldClearTable]);

  useEffect(() => {
    if (shouldRebindCanvas) {
      setIsRebindCanvas(true);
    }
  }, [shouldRebindCanvas]);

  useEffect(() => {
    if (isRebindCanvas) {
      setIsRebindCanvas(false);
    }
  }, [isRebindCanvas]);

  return rows.map((row, i) => (
    <VirtualSection
      key={row.key}
      rowIndex={row[rowIndexKey]}
      index={index}
      childrenNodes={childrenNodes}
      isHidden={isHidden || row.isFilteredOut}
      isViewOnly={isViewOnly || disableEditFilter[row[rowIndexKey]]}
      containersProps={containersProps}
      isParentlessTable={isParentlessTable}
      gridIndex={i}
    />
  ));
};

export default SSVirtualRepeatingPanel;
